import classNames from 'classnames';
import React from 'react';
import CodeSparkThemedTypography from '../../../../components/elements/CodeSparkThemedTypography';
import { ImageTextRow, Image, TextContent } from '../../../../components/elements/ImageTextRow';

import styles from './ActivateCodingSkills.module.css';

function CodingSkillRow({ header, body, valueProps, img, reverse }) {
  return (
    <ImageTextRow className={styles.activateCodingSkillsRow}>
      <Image
        src={img}
        alt={header}
        className={classNames(
          reverse ? 'large-order-2' : 'large-order-1',
          styles.activateCodingSkillsRowImage
        )}
      />

      <TextContent className={reverse ? 'large-order-1' : 'large-order-2'}>
        <CodeSparkThemedTypography variant="h3" className={styles.activateCodingSkillsRowHeader}>
          {header}
        </CodeSparkThemedTypography>

        <CodeSparkThemedTypography
          variant="subtitle2"
          className={styles.activateCodingSkillsRowBody}
        >
          {body}
        </CodeSparkThemedTypography>

        <ul className={styles.activateCodingSkillsRowValueProps}>
          {valueProps.map((valueProp, i) => {
            return (
              <li key={`coding_skill_value_props${i}`}>
                <CodeSparkThemedTypography variant="body2">{valueProp}</CodeSparkThemedTypography>
              </li>
            );
          })}
        </ul>
      </TextContent>
    </ImageTextRow>
  );
}

export default CodingSkillRow;



// WEBPACK FOOTER //
// ./src/containers/Home/sections/ActivateCodingSkills/CodingSkillRow.js